import React, { useState } from 'react';
import ProjectDetail from './projectDetail';

function ProjectsList({ projects }) {
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 15;
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const displayKeys = ['name', 'BudgetAllocated', 'purpose'];
  if (!projects.length) return <p>No projects available.</p>;

  const keys = Object.keys(projects[0]);
  const totalPages = Math.ceil(projects.length / rowsPerPage);

  const currentRows = projects.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <div className="container-fluid mt-4">
      <h4 className="mb-3">Projects List</h4>
      <div style={{ overflowX: 'auto',fontSize:"17px" }}>
        <table className="table table-hover table-bordered">
          <thead className="table-light">
            <tr>
              <th>Project Title</th>
              <th>Project Value(USD)</th>
              <th>Purpose</th>
              
            </tr>
          </thead>
          

<tbody>
  {currentRows.map((project, rowIndex) => (
    <tr key={rowIndex}>
      {displayKeys.map((key, colIndex) => (
        <td
          key={key}
          style={colIndex === 0 ? { cursor: 'pointer', color: 'blue', textDecoration: 'none' } : {}}
          onClick={colIndex === 0 ? () => setSelectedProjectId(project.ID) : undefined}
        >
          {project[key] ?? 'N/A'}
        </td>
      ))}
    </tr>
  ))}
</tbody>


        </table>
      </div>
        
      {/* Pagination */}
      <nav>
        <ul className="pagination justify-content-center gap-2">
          <li className={`page-item ${currentPage === 1 && 'disabled'}`}>
            <button className="page-link" onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}>
              Previous
            </button>
          </li>
          {[...Array(totalPages)].map((_, i) => (
            <li key={i} className={`page-item ${currentPage === i + 1 && 'active'}`}>
              <button className="page-link" onClick={() => setCurrentPage(i + 1)}>
                {i + 1}
              </button>
            </li>
          ))}
          <li className={`page-item ${currentPage === totalPages && 'disabled'}`}>
            <button className="page-link" onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}>
              Next
            </button>
          </li>
        </ul>
      </nav>
       {selectedProjectId && (
  <ProjectDetail projects={projects} project_id={selectedProjectId} onClose={() => setSelectedProjectId(null)} />
)}
    </div>
    
  );
}

export default ProjectsList;
